import { Instagram, Mail, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/smoothScroll";
import { WHATSAPP } from "../data/content";

export const Footer = () => (
  <footer data-testid="main-footer" className="relative bg-[#181410] border-t border-amber-500/10 overflow-hidden">
    <Reveal>
      <button
        data-testid="footer-big-cta"
        onClick={() => scrollToId("#preventivo")}
        className="block w-full text-center py-16 sm:py-20 group"
      >
        <span className="font-serif text-[9vw] sm:text-[6vw] leading-none tracking-tight text-transparent bg-clip-text bg-gradient-to-b from-amber-300/90 to-amber-500/30 group-hover:from-amber-200 group-hover:to-amber-400/60 transition-all duration-700">
          ILLUMINA IL TUO EVENTO
        </span>
      </button>
    </Reveal>

    <div className="max-w-7xl mx-auto px-5 sm:px-8 pb-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-3 border-t border-amber-500/10 pt-12">
      <div>
        <Logo />
        <p className="mt-4 text-sm text-stone-400 leading-relaxed max-w-xs">
          Noleggio attrezzature per eventi, allestimenti luminosi e decorazioni natalizie.
        </p>
      </div>
      <div>
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-amber-400/90 mb-4">Contatti</p>
        <ul className="space-y-3 text-sm text-stone-300">
          <li>
            <a data-testid="footer-phone-link" href={`tel:+${WHATSAPP.phone}`} className="flex items-center gap-2.5 hover:text-amber-300 transition-colors">
              <Phone className="w-4 h-4 text-amber-400/70" /> {WHATSAPP.displayPhone}
            </a>
          </li>
          <li>
            <a data-testid="footer-email-link" href="mailto:info@lmserviceevent.com" className="flex items-center gap-2.5 hover:text-amber-300 transition-colors">
              <Mail className="w-4 h-4 text-amber-400/70" /> info@lmserviceevent.com
            </a>
          </li>
          <li>
            <a data-testid="footer-instagram-link" href="https://instagram.com/lmserviceevent" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 hover:text-amber-300 transition-colors">
              <Instagram className="w-4 h-4 text-amber-400/70" /> @lmserviceevent
            </a>
          </li>
        </ul>
      </div>
      <div>
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-amber-400/90 mb-4">Navigazione</p>
        <ul className="space-y-3 text-sm text-stone-300">
          {[
            ["Catalogo", "#catalogo", "footer-nav-catalogo"],
            ["Servizi & Posa", "#servizi", "footer-nav-servizi"],
            ["Preventivo", "#preventivo", "footer-nav-preventivo"],
          ].map(([label, hash, id]) => (
            <li key={hash}>
              <button data-testid={id} onClick={() => scrollToId(hash)} className="hover:text-amber-300 transition-colors">
                {label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="border-t border-amber-500/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs font-mono text-stone-500">
        <span>© 2026 LMserviceevent • lmserviceevent.com</span>
        <span>P.IVA 04773130986 • Fornitura & Installazione</span>
      </div>
    </div>
  </footer>
);
